import { Avatar } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

import { AccountLike } from "./types";
import CurrentAccountIndicator from "./CurrentAccountIndicator";
import styles from "./AccountIcon.module.css";

interface AccountIconProps {
  account: AccountLike;
  isCurrentAccount: boolean;
}

const AccountIcon = ({ account, isCurrentAccount }: AccountIconProps) => (
  <div className={styles.accountIcon}>
    <AccountAvatar account={account} />
    <CurrentAccountIndicator isCurrentAccount={isCurrentAccount} />
  </div>
);

interface AccountAvatarProps {
  account: AccountLike | null;
}

const AccountAvatar = ({ account }: AccountAvatarProps) => {
  if (account?.avatarUrl) {
    return (
      <div data-testid="account-avatar">
        <Avatar
          isBlock
          name={account.name}
          size="medium"
          url={account.avatarUrl}
        />
      </div>
    );
  }

  return (
    <div data-testid="account-icon">
      <Icon isBlock color="GrayWarm9" name="personCircle" size={40} />
    </div>
  );
};

export default AccountIcon;
